import { Component, OnInit, HostListener, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { VodDataRestService } from "../../../data/vod/vod-data-rest.service";
import { CategoryP } from "../../../data/cms-vod-client-api";
import { LabelP } from "../../../data/360-client-api";
import { Subscription } from "rxjs";
import { DataSharingService } from "../../../core/data-sharing/data-sharing.service";
import { PodcastDataRestService } from "../../../data/podcast/podcast-data-rest.service";
import { PodcastGroup } from "../../../data/podcast-client-api/model/podcastContent";
import { ThrowStmt } from "@angular/compiler";
import { PostGroupP } from "../../../data/blog-client-api";
import { BlogDataRestService } from "../../../data/blog/blog-data-rest.service";

declare var $: any;

@Component({
  selector: "app-mobile-menu",
  templateUrl: "./mobile-menu.component.html",
  styleUrls: ["./mobile-menu.component.css"],
})
export class MobileMenuComponent implements OnInit, OnDestroy {
  categoryID: number;
  mainCategory: CategoryP = {};
  labels: LabelP[] = [];
  routerSubs: Subscription;
  isDashboard: boolean;
  categories: CategoryP[];
  lastScrollTop: number = 0;
  podcastGroups: PodcastGroup[] = [];
  blogGroups: PostGroupP[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dataSource: VodDataRestService,
    private dataSharing: DataSharingService,
    private podcastService: PodcastDataRestService,
    private blogService: BlogDataRestService
  ) {
    // this.routerSubs = this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.isDashboard = this.router.url.includes('dashboard');
    //     if (this.isDashboard) {
    //       this.getMenuLabels();
    //     }
    //   }
    // });
    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.router.url.includes("dashboard/")) {
          this.getMenuLabels();
        } else if (
          this.router.url.includes("podcastGrid") ||
          this.router.url.includes("podcastDetail")
        ) {
          this.getPodcastGroups();
        } else if (this.router.url.includes("blog")) {
          this.getBlogGroups();
        } else {
          this.getMenuLabelsReq(true);
        }
      }
    });
  }

  ngOnInit() {
    let mobileMenu = document.getElementById("mobileMenu");

    $(document).ready(function () {
      // Transition effect for navbar
      $(window).scroll(function () {
        let st = $(this).scrollTop();
        // checks if window is scrolled more than 250px, adds/removes solid class
        // var st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > 150) {
          if (st > this.lastScrollTop) {
            // downscroll code
            mobileMenu.style.height = "0px";
          } else {
            // upscroll code
            mobileMenu.style.height = "50px";
          }
          this.lastScrollTop = st;
        }
        // this.lastScrollTop = st <= 0 ? 0 : st;
      });
    });

    this.getActiveCategories();
  }

  getActiveCategories() {
    this.dataSource.getActiveCategories().subscribe((data) => {
      this.categories = data;
      this.mainCategory = this.categories.find((item) => item.main == true);
      this.getMenuLabels();
    });
    this.getMenuLabels();
  }

  routeSubs: Subscription;
  getMenuLabels() {
    if (
      this.router.url.includes("podcastGrid") ||
      this.router.url.includes("podcastDetail")
    ) {
      this.getPodcastGroups();
      return;
    }
    if (
      this.router.url.includes("blog") ||
      this.router.url.includes("blogDetail")
    ) {
      this.getBlogGroups();
      return;
    }

    this.routeSubs = this.route.children[0].params.subscribe((route) => {
      if (this.router.url.includes("dashboard")) {
        this.categoryID = route.id;
      }

      if (this.categoryID == -1) {
        this.getPodcastGroups();
        if (this.routeSubs) {
          this.routeSubs.unsubscribe();
          this.routeSubs = null;
        }
        return;
      }
      if (this.categoryID == -2) {
        this.getBlogGroups();
        if (this.routeSubs) {
          this.routeSubs.unsubscribe();
          this.routeSubs = null;
        }
        return;
      }
      if (!this.categoryID) {
        this.categoryID = this.mainCategory.id;
      }
      this.getMenuLabelsReq();
    });
  }

  getMenuLabelsReq(isFromElse: boolean = false) {
    if (isFromElse) {
      this.categoryID = this.mainCategory.id;
    }
    this.dataSource.getMenuLabels(this.categoryID).subscribe((data) => {
      if (data) {
        this.labels = data;
        if (this.routeSubs) {
          this.routeSubs.unsubscribe();
          this.routeSubs = null;
        }
      }
    });
  }

  getPodcastGroups() {
    this.podcastService.getPodcastGroups().subscribe((data) => {
      if (data) {
        this.categoryID = -1;
        this.podcastGroups = data;
      }
    });
  }

  getBlogGroups() {
    this.blogService.getBlogGroups().subscribe((data) => {
      if (data) {
        this.categoryID = -2;
        this.blogGroups = data;
      }
    });
  }

  showModal() {
    $("#modal-labels").modal("show");
  }

  ngOnDestroy() {
    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
      this.routerSubs = null;
    }
    if (this.routeSubs) {
      this.routeSubs.unsubscribe();
      this.routeSubs = null;
    }
  }

  sendLabelName(labelName: string) {
    setTimeout(() => {
      this.dataSharing.sendLabelName(labelName);
    }, 100);
  }

  closeModal() {
    $("#modal-labels").modal("hide");
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/layouts/widgets/mobile-menu/mobile-menu.component.ts